/** @jsxImportSource @emotion/react */
import React from 'react';
import useStyle from './ProductsNav.style';

const headerLinks = {
  'All Products': '/products/',
  'Home Security': '/products/home-security/',
  Cameras: '/products/cameras/',
  Environmental: '/environmental/',
};

const services = {
  '': [
    {
      name: 'All Services',
      to: '/services',
    },
    {
      name: 'Professional Installation',
      to: '/professional-installation',
    },
    {
      name: 'Monitoring',
      to: '/monitored-security',
    },
  ],
};

function groupArr(data: any[], count: number = 0) {
  var group: any[] = [];
  for (var i = 0, j = 0; i < data.length; i++) {
    if (i >= count && i % count === 0) j++;
    group[j] = group[j] || [];
    group[j].push(data[i]);
  }
  return group;
}

const MobileServicesNav = () => {
  const s = useStyle();

  return (
    <div css={s.container}>
      {Object.keys(services).map((key, i) => {
        return (
          <div key={i}>
            <h5>
              <a href={`${headerLinks[key as keyof typeof headerLinks]}`}>
                {key}
              </a>
            </h5>
            <div className="items">
              {groupArr(services[key as keyof typeof services], 3).map(
                (group, j) => {
                  return (
                    <div key={j}>
                      {group.map((product, k) => {
                        return (
                          <a href={product.to} key={k}>
                            {product.name}
                          </a>
                        );
                      })}
                    </div>
                  );
                }
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileServicesNav;
